module.exports = __webpack_public_path__ + "img/norberto-echevarria-byn.06523626.jpg";